// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'sub-step';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.375 5.25h-8.25C.9 5.25.75 5.1.75 4.875v-2.25c0-.225.15-.375.375-.375h8.25c.225 0 .375.15.375.375v2.25c0 .15-.15.375-.375.375zm7.5 10.5H5.625c-.225 0-.375-.15-.375-.375v-2.25c0-.225.15-.375.375-.375h11.25c.225 0 .375.15.375.375v2.25c0 .15-.15.375-.375.375zm-7.125-12H12c.225 0 .375.15.375.375V10.5' />
    <path d='m10.875 9 1.5 1.5 1.5-1.5' />
  </g>
);

export const viewBox = '0 0 18 18';
